export const CORS_PROXIES = [
  'https://api.allorigins.win/raw?url=',
  'https://corsproxy.io/?',
  'https://api.codetabs.com/v1/proxy?quest='
];

export const UPDATE_INTERVAL = 900000; // 15 minutes
export const MAX_RETRIES = 5;
export const RETRY_DELAY = 3000; // 3 seconds
export const FETCH_TIMEOUT = 20000; // 20 seconds
export const CACHE_DURATION = 3600000; // 1 hour

export const API_HEADERS = {
  'Accept': 'application/rss+xml, application/xml, text/xml, application/atom+xml, */*',
  'User-Agent': 'Mozilla/5.0 (compatible; QuantumBytz/1.0; +https://quantumbytz.com)'
};
